// extracted by mini-css-extract-plugin
export default {"industryModel":"styles_industryModel__B54n8","boxModel":"styles_boxModel__ClG8r","cross":"styles_cross__GCefE"};